import { CreateClientParams, IClient } from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllClientsService = async (
  params?: BaseFilterParams
): Promise<APIPaginationResponse<IClient[]>> => {
  const res = await axiosInstance.get('clients', { params });
  return res.data;
};

export const getClientByIdService = async (id: number): Promise<IClient> => {
  const res = await axiosInstance.get(`clients/${id}`);
  return res.data.data;
};

export const createClientService = async (
  params: CreateClientParams
): Promise<{ id: number }> => {
  const res = await axiosInstance.post('clients', params);
  return res.data.data;
};

export const updateClientService = async (
  id: number,
  params: CreateClientParams
): Promise<unknown> => {
  const res = await axiosInstance.put(`clients/${id}`, params);
  return res.data;
};

export const updateStatusClientService = async (
  id: number,
  status: number
): Promise<void> => {
  await axiosInstance.put(`clients/${id}/update-status`, { status });
};

export const changeStatusClientManyIdService = async (
  ids: number[],
  status: number
): Promise<void> => {
  await axiosInstance.put('clients/update-status-with-many-id', {
    status,
    ids,
  });
};

export const deleteClientService = async (params: {
  ids: number[];
}): Promise<void> => {
  await axiosInstance.delete('clients', { data: params });
};

export const uploadChunkService = async (data: IChunkData): Promise<void> => {
  const formData = new FormData();
  formData.append('qquuid', data.qquuid);
  formData.append('qqfile', data.qqfile);
  await axiosInstance.post('clients/files/upload-chunk', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const mergeChunkService = async (
  data: IMergeChunkData
): Promise<IMergeChunkResponse> => {
  const response = await axiosInstance.post('clients/files/merge-chunk', data);
  return response.data.data;
};

export const sendMailToClientService = async (id: number): Promise<void> => {
  await axiosInstance.post(`clients/${id}/send-mail-admin-account`);
};
